import { EuiAppShellService } from '@eui/core';
import { TimelineItemComponent } from './timeline-item.component';
import { Component, Input, ContentChildren } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-sgp-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent {

    @ContentChildren(TimelineItemComponent) childrenSteps;

    /**
     * The align of the description below circle boxes
     * Values: center, end
     */
    @Input()
    contentAlign: string = 'center';

    /**
     * A theme for bullets, default is yellow
     * Values: yellow, blue
     */
    @Input()
    theme: string = 'yellow';

    constructor(private asService: EuiAppShellService) {
    }

    openModal(modalId: string) {
        //  this.asService.openModal(modalId);
    }
}
